// Slab data is purely for display in the right-side reference panel.
// Tax computation is performed by the backend and never recomputed in the UI.

export const NEW_REGIME_SLABS = [
  { from: 0, to: 400000, rate: '0%' },
  { from: 400001, to: 800000, rate: '5%' },
  { from: 800001, to: 1200000, rate: '10%' },
  { from: 1200001, to: 1600000, rate: '15%' },
  { from: 1600001, to: 2000000, rate: '20%' },
  { from: 2000001, to: 2400000, rate: '25%' },
  { from: 2400001, to: null, rate: '30%' },
];

export const OLD_REGIME_SLABS = [
  { from: 0, to: 250000, rate: '0%' },
  { from: 250001, to: 500000, rate: '5%' },
  { from: 500001, to: 1000000, rate: '20%' },
  { from: 1000001, to: null, rate: '30%' },
];

export const ASSESSMENT_YEARS = [
  { value: '2027-28', label: 'AY 2027-28', isNew: true },
  { value: '2026-27', label: 'AY 2026-27', isNew: false },
];

export const BLANK_INPUTS = {
  // Basic info
  age: '',
  residential_city_type: 'metro',
  assessment_year: '2027-28',
  // Income
  annual_salary: 0,
  business_income: 0,
  savings_interest: 0,
  other_interest: 0,
  other_income: 0,
  annual_rental_income: 0,
  loan_interest_on_let_out: 0,
  municipal_taxes_let_out: 0,
  // Deductions
  sec_80c: 0,
  sec_24b_self_occupied: 0,
  sec_80e_education_loan: 0,
  annual_rent_paid: 0,
  annual_basic_da: 0,
  health_ins_self: 0,
  health_ins_parents: 0,
  nps_80ccd_1b: 0,
  employer_nps_80ccd_2: 0,
  others: 0,
};

export const INCOME_FIELDS = [
  { key: 'annual_salary', label: 'Annual Salary' },
  { key: 'business_income', label: 'Business Income' },
  { key: 'savings_interest', label: 'Savings A/C Interest' },
  { key: 'other_interest', label: 'Other Interest Income' },
  { key: 'other_income', label: 'Other Income' },
  { key: 'annual_rental_income', label: 'Annual Rental Income' },
  { key: 'loan_interest_on_let_out', label: 'Interest paid for loans on houses on rent' },
  { key: 'municipal_taxes_let_out', label: 'Municipal taxes paid on houses on rent' },
];

export const DEDUCTION_FIELDS = [
  { key: 'sec_80c', label: 'Tax Saving Investment (80C)' },
  { key: 'sec_24b_self_occupied', label: 'Int. paid on self occupied home loan' },
  { key: 'sec_80e_education_loan', label: 'Interest paid on Educational Loan' },
  { key: 'annual_rent_paid', label: 'Annual Rent Paid' },
  { key: 'annual_basic_da', label: 'Annual Basic + DA (to calculate rent deductions)' },
  { key: 'health_ins_self', label: 'Health Insurance Self' },
  { key: 'health_ins_parents', label: 'Health Insurance Parents' },
  { key: 'nps_80ccd_1b', label: 'NPS Contribution 80CCD(1)' },
  { key: 'employer_nps_80ccd_2', label: 'Employer contribution to NPS Section 80CCD(2)' },
  { key: 'others', label: 'Others' },
];

export const formatINR = (value) => {
  const num = Number(value || 0);
  if (Number.isNaN(num)) return '₹0';
  return '₹' + num.toLocaleString('en-IN', { maximumFractionDigits: 0 });
};
